import { render, staticRenderFns } from "./ParentFirmView.vue?vue&type=template&id=c1837248&"
import script from "./ParentFirmView.vue?vue&type=script&lang=js&"
export * from "./ParentFirmView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports